export default {
  roles: state => state.roles,
  roleInfos: state => state.roleInfos,
}
